import { Trans } from "@lingui/react/macro";
import { useNavigate } from "@tanstack/react-router";
import { ShieldOff } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AccessRestrictedPageProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
}

export function AccessRestrictedPage({
  title,
  description,
}: AccessRestrictedPageProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center px-4">
      <div className="rounded-full bg-(--color-danger)/10 p-5">
        <ShieldOff className="h-10 w-10 text-(--color-danger-text)" />
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-(--color-text-primary)">
          {title ?? <Trans>Access Restricted</Trans>}
        </h1>
        <p className="text-(--color-text-secondary) max-w-sm">
          {description ?? (
            <Trans>You do not have permission to access this page.</Trans>
          )}
        </p>
      </div>
      <Button onClick={() => void navigate({ to: "/dashboard" })}>
        <Trans>Go to Dashboard</Trans>
      </Button>
    </div>
  );
}